import { render, staticRenderFns } from "./MobileRecoveryLegalMentions.vue?vue&type=template&id=122feb3e&scoped=true"
import script from "./MobileRecoveryLegalMentions.vue?vue&type=script&lang=js"
export * from "./MobileRecoveryLegalMentions.vue?vue&type=script&lang=js"
import style0 from "./MobileRecoveryLegalMentions.vue?vue&type=style&index=0&id=122feb3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122feb3e",
  null
  
)

export default component.exports